import React from 'react'
import { registerPlugin } from '@wordpress/plugins'
import { PluginDocumentSettingPanel } from '@wordpress/edit-post'
import IfPostType from '../../source/components/IfPostType'
import { TextControl, TextareaControl } from '@wordpress/components'
import useSelect from '../../source/hooks/useSelect'
import { useEntityProp } from '@wordpress/core-data'

function PostMetaEditor() {
  const [postType, postId] = useSelect((select) => [
    select('core/editor').getCurrentPostType(),
    select('core/editor').getCurrentPostId()
  ])
  const [meta, updateMeta] = useEntityProp(
    'postType',
    postType,
    'meta',
    String(postId)
  )

  return (
    <PluginDocumentSettingPanel
      name="yellowtree-post-meta-panel"
      title="Allgemein"
    >
      {'subline' in meta && (
        <TextControl
          label="Subline (optional)"
          value={meta.subline ?? ''}
          onChange={(subline) => updateMeta({ ...meta, subline })}
        />
      )}
      <IfPostType equals="teacher">
        <TextareaControl
          label="Kurzbeschreibung"
          help="Diese Beschreibung wird angezeigt, wenn auf diesen Mitarbeiter verwiesen wird."
          value={meta.bio ?? ''}
          onChange={(bio) => updateMeta({ ...meta, bio })}
        />
      </IfPostType>
    </PluginDocumentSettingPanel>
  )
}

registerPlugin('yellowtree-post-meta', {
  render: () => {
    return (
      <IfPostType in={['post', 'teacher']}>
        <PostMetaEditor />
      </IfPostType>
    )
  },
  icon: 'admin-users'
})
